export class StatusMotorista {
    identificador: string;
    status: Status;
    detalhes: Detalhe;
}

export class Status{
    codigo: number;
    mensagem: string;
    mensagemCor: string;
    observacao: string;
    observacaoCor: string;
    codigoLogFaturamento: string;
    validadeFicha: Date;
    numeroLiberacao: number;
    dataInclusao: Date;
    profissionalTipo: number;
}

export class Detalhe{
    nome: string;
    celular: string;
    rg: string;
    data_nascimento: Date;
    cnh: string;
    nome_mae: string;
    nome_pai: string;
}